import Lottie from 'lottie-react';
import steps from './steps.json';
import { FC } from 'react';

const LaunchSteps: FC = () => {
  return (
    <div className="launch-steps">
      <h2>
        Launch Your Algo in <span>4 steps</span>
      </h2>
      <div className="launch-steps__content">
        <Lottie animationData={steps} renderer="svg" />
      </div>
    </div>
  );
};

export default LaunchSteps;
